import {
  getRelateDatas,
  getRelateDevpDatas,
  getRelateOrigionDatas,
  subrelationDatas
} from '@/services/config'
export default {
  namespaced: true,
  state: {
    submitting: false,
    datasReady: false,
    developDatasReady: false,
    datas: [],
    developDatas: [],
    orginDatas: {},
    treeItemObj: {},
    decorators: {
    }
  },
  mutations: {
    // 设置数据容器的值
    setDatas (state, datas) {
      state.datas = datas
      state.datasReady = true
    },
    setSubmitting (state, type) {
      state.submitting = type
    },
    setDevelopDatas (state, datas) {
      state.developDatas = datas
    },
    setOrginDatas (state, datas) {
      state.orginDatas = datas
    },
    setTreeItemObj (state, obj) {
      state.treeItemObj = obj
    }
  },
  getters: {
    currentData (state) {
      const { datas } = state
      datas.forEach((item, index) => {
        item.key = item.id || item._id
      })
      return datas || []
    },
    currentDevelopDatas (state) {
      const { developDatas } = state
      function dataLoop (arr, pid) {
        arr.forEach((item, index) => {
          item.value = item.id + item.keyname
          item.label = item.name
          // item.title = item.name
          item.key = item.id
          item['pid'] = pid
          if (item.pid) {
            item.key = pid + '-' + item.id
          } else {
            item.key = item.id
          }
          item.scopedSlots = { title: 'title' }
          let key = item.keyname
          let obj = {}
          obj[key] = item.id
          item.title = {
            newObj: obj,
            title: item.name,
            'key': item.key,
            hasChild: !!(item.children && item.children.length)
          }
          if (item.children && item.children.length) {
            dataLoop(item.children, item.id)
          }
        })
      }
      dataLoop(developDatas, null)
      state.developDatasReady = true
      return developDatas || []
    }
  },
  actions: {
    async fetchRelationDatas ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getRelateDatas()
        .onSuccess((raw) => {
          commit('setDatas', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async fetchRelationDevpDatas ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getRelateDevpDatas()
        .onSuccess((raw) => {
          commit('setDevelopDatas', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async fetchRelationOrigionDatas ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getRelateOrigionDatas()
        .onSuccess((raw) => {
          commit('setOrginDatas', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async subRule ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await subrelationDatas()
        .onSuccess(async () => {
          // const res = await dispatch('fetchCollectDatas', type)
          // res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    }

  }
}
